import React, { PureComponent } from 'react';
import axios from 'axios';
import HeaderContentView from './headerContent/headerContentView';
import HeaderContentEdit from './headerContent/headerContentEdit';
import AppConstant from '../../../constants/app';

const fetchContentData = () =>  axios.get(`${AppConstant.API_URL}/header`)

class HeaderContent extends PureComponent {
  state = {
    isEditSection: false,
    headerContentData: [],
    logoImage: '',
    myFiuUrl: '',
    items: [],
    menuColor: ''
  };

  componentDidMount () {
    this.getHeaderData();
  }

  getHeaderData = () => {
    fetchContentData()
    .then(res => {
      const headerContentData = res.data;
      this.onChangeLinksList(headerContentData.header.menu_items);
      this.setState({
        headerContentData,
        logoImage: headerContentData.header.logo.image,
        myFiuUrl: headerContentData.header.login_url,
        menuColor: headerContentData.header.menu_color,
      });
    }).catch(error => {
      console.log(error);
    })
  }

  onChangeLinksList = (list) => {
    const sortedList = list.sort((element1, element2) => {
      let keyA = element1.position,
          keyB = element2.position;

      if(keyA < keyB) return -1;
      if(keyA > keyB) return 1;
      return 0;
    });

    this.setState({
      items: sortedList,
    })
  };

  addMenuItem = () => {
    let position = this.state.items.length > 0 ? this.state.items.reduce((prev, current) => (prev.y > current.y) ? prev : current).position + 1 : 1;

    const newElement = {
      'id': 1,
      'label': '',
      'url': '',
      'hidden': 0,
      "position": position,
    }

    this.setState(prevState => ({
      items: [...prevState.items, newElement]
      })
    );
  };

  deleteItem = (item) => {
    const newList = this.state.items.filter(element => ( element !== item ));

    this.setState({
      items: newList,
    });
  };

  hideItem = (index) => {
    const {
      items,
    } = this.state;

    const newList = items.map(item => item);
    newList[index]['hidden'] = newList[index]['hidden'] === 0 ? 1: 0;
    this.setState({ items: newList });
  };

  onChangeItem = (newValue, key, index) => {
    const {
      items,
    } = this.state;

    const newList = items.map(item => item);

    newList[index][key] = newValue;

    this.setState({ items: newList });
  };

  onCancelEdit = () => {
    fetchContentData()
      .then(({data:headerContentData}) => {
        this.setState({ 
          items: headerContentData.header.menu_items,
          logoImage: headerContentData.header.logo.image,
          myFiuUrl: headerContentData.header.login_url,
        });
      })

    this.setState({ isEditSection: false });
  }

  handleInputChange = (val, name) => {
    this.setState({[name]: val});
  }

  render () {
    const {
      isEditSection,
      logoImage,
      myFiuUrl,
      items,
      headerContentData,
      menuColor
    } = this.state;

    return (
      <div>
        {
          !isEditSection
          ? <HeaderContentView
              headerData={headerContentData.header}
              logoImage={logoImage}
              myFiuURL={myFiuUrl}
              menuColor={menuColor}
              items={items}
              onClickEdit={
                () => {
                  this.setState({ isEditSection: true });
                }
              }
              onChangeLinksList={this.onChangeLinksList}
              getHeaderData={this.getHeaderData}
            />
          : <HeaderContentEdit
              headerData={headerContentData.header}
              addMenuItem={this.addMenuItem}
              deleteItem={this.deleteItem}
              hideItem={this.hideItem}
              onChangeItem={this.onChangeItem}
              onChangeInput={this.handleInputChange}
              items={items}
              myFiuURL={myFiuUrl}
              menuColor={menuColor}
              onClickCancelEdit={this.onCancelEdit}
              getHeaderData={this.getHeaderData}
            />
        }
      </div>
    )
  }
}

export default HeaderContent;



// WEBPACK FOOTER //
// ./src/app/screens/general/headerContent.js